"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appStateSelectAppId_1 = __importDefault(require("../../shared/appStateSelectAppId"));
const appStateSelectProjectId_1 = __importDefault(require("../../shared/appStateSelectProjectId"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const clientAppOnAuthenticated_1 = __importDefault(require("../clientAppOnAuthenticated"));
const buildCallableLoginWithGoogle = (args) => async ({ functionId, callbacks, executeProcesses, processor, store, }) => {
    try {
        const state = store.getState();
        const projectId = (0, appStateSelectProjectId_1.default)(state);
        const appId = (0, appStateSelectAppId_1.default)(state);
        await args.localLoginWithGoogle({ appId });
        await (0, clientAppOnAuthenticated_1.default)({
            appId,
            processor,
            projectId,
        });
        if (processor.root.isInDevelopment && args.onUserLoggedInDevelopment) {
            await args.onUserLoggedInDevelopment({ appId });
        }
        executeProcesses(undefined, callbacks.successProcess);
    }
    catch (error) {
        const state = args.identifyState({
            types: {
                cancelled: 0 /* GOOGLE_STATUS_TYPES.CANCELLED */,
                inProgress: 1 /* GOOGLE_STATUS_TYPES.IN_PROGRESS */,
                playServicesNotAvailable: 2 /* GOOGLE_STATUS_TYPES.PLAY_SERVICES_NOT_AVAILABLE */,
                unknown: 3 /* GOOGLE_STATUS_TYPES.UNKNOWN */,
            },
            error: (0, valueIsRecord_1.default)(error) ? error : {},
        });
        switch (state) {
            case 0 /* GOOGLE_STATUS_TYPES.CANCELLED */:
                executeProcesses(functionId, callbacks.signInCancelled, 'You cancel de login operation');
                break;
            case 1 /* GOOGLE_STATUS_TYPES.IN_PROGRESS */:
                executeProcesses(functionId, callbacks.inProgress, 'The login operation is already in process');
                break;
            case 2 /* GOOGLE_STATUS_TYPES.PLAY_SERVICES_NOT_AVAILABLE */:
                executeProcesses(functionId, callbacks.PlayServicesNotAvailable, 'Play services are not available or outdated');
                break;
            default:
                executeProcesses(functionId, callbacks.errorProcess, error);
        }
    }
};
exports.default = buildCallableLoginWithGoogle;
